<template>
  <el-row>
    <el-col :span="11">
      <el-divider content-position="left">每月单量/金额
        <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false" title="点击刷新"
                 @click="getPlatformMonthData"><i
            class="el-icon-refresh-right"/></el-link>
      </el-divider>

      <el-table class="dashboard-table"
                show-summary
                :summary-method="getSummaries"
                :data="dataMonths"
                style="width: 100%">
        <el-table-column prop="month" label="月份" align="center" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.month }}月
          </template>
        </el-table-column>
        <el-table-column prop="order_count" label="订单数" align="right" header-align="right" min-width="100"/>
        <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`" align="right"
                         header-align="right" min-width="120">
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.order_money) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="left" header-align="center" min-width="240">
          <template slot-scope="scope">
            <ol v-html="scope.row.remark"></ol>
          </template>
        </el-table-column>
      </el-table>

<!--      <el-table class="dashboard-table"-->
<!--                show-summary-->
<!--                :summary-method="getSummaries"-->
<!--                :data="dataOrderTable"-->
<!--                style="width: 100%;">-->
<!--        <el-table-column prop="month" label="月份" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.month }}月-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="order_count" label="订单数" align="right" header-align="right"/>-->
<!--        <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`" align="right"-->
<!--                         header-align="right">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ gFunc.numberFormat(scope.row.order_money) }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column v-for="item in dataOrderTableHeader" align="right"-->
<!--                         :prop="item"-->
<!--                         :key="item"-->
<!--                         v-bind:label="item"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ gFunc.numberFormat(scope.row[item]) }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </el-col>
    <el-col :span="13">
      <el-row>
        <div id="orderCountChart" style="width: 100%;height: 280px;"/>
      </el-row>
      <el-row>
        <div id="orderMoneyChart" style="width: 100%;height: 280px;"/>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import {platformDetailMonth, platformDetailOrder} from "@/api/dashboard";
import * as echarts from 'echarts';

export default {
  name: "orderModule",
  components: {},
  props: {
    searchCondition: {
      type: Object,
      default() {
        return {
          year: 2021,
          platformName: '--',
          platformCode: null,
          organization_id: null,
        }
      }
    },
    year: [Number, String],
    platformName: [String],
    platformCode: [String],
  },
  data() {
    let xAxis = [];
    for (let i = 1; i <= 12; i++) {
      xAxis.push(i + '月')
    }
    return {
      data: [],
      dataMonths: [],
      dataOrderTable: [],
      dataOrderTableHeader: [],
      dataChartOrderCount: [],
      dataChartOrderMoney: [],
      xAxis: xAxis,
      total_count: 0,
      total_money: 0,
    }
  },
  created() {
    // this.getOrderData();
    this.getPlatformMonthData()
  },
  methods: {
    getPlatformMonthData() {
      platformDetailMonth({
        year: this.searchCondition.year,
        organization_id: this.searchCondition.organization_id,
        platform_name: this.searchCondition.platformName,
        platform_code: this.searchCondition.platformCode
      }).then((res) => {
        // eslint-disable-next-line
        if (res.model) {
          this.dataMonths = res.model

          this.dataChartOrderCount = this.dataMonths.map(item => {
            return item.order_count;
          });
          this.dataChartOrderMoney = this.dataMonths.map(item => {
            return item.order_money;
          });
          this.initChart()
        }

      })
    },
    getOrderData() {
      platformDetailOrder({
        year: this.searchCondition.year,
        platform_name: this.searchCondition.platformName,
        platform_code: this.searchCondition.platformCode
      }).then((res) => {
        this.dataOrderTableHeader = res.model.headers || [];
        this.dataOrderTable = res.model.data || []
        this.dataChartOrderCount = res.model.data.map(item => {
          return item.order_count;
        });
        this.dataChartOrderMoney = res.model.data.map(item => {
          return item.order_money;
        });
        this.initChart()
      })
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if ([...['order_money', 'order_count'], ...this.dataOrderTableHeader].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          sums[index] = this.gFunc.numberFormat(sums[index]);
        }
      });
      return sums
    },
    initChart() {
      this.initCountChart()
      this.initMoneyChart()
    },
    initCountChart() {
      const myChart = echarts.init(document.getElementById('orderCountChart'));
      let option;
      option = {
        title: {
          text: '订单量',
          padding: [0, 0, 0, 50]
        },
        xAxis: {
          type: 'category',
          data: this.xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.dataChartOrderCount,
          type: 'line'
        }]
      };
      option && myChart.setOption(option);
    },
    initMoneyChart() {
      const myChart = echarts.init(document.getElementById('orderMoneyChart'));
      let option;
      option = {
        title: {
          text: '订单金额',
          padding: [0, 0, 0, 50]
        },
        xAxis: {
          type: 'category',
          data: this.xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.dataChartOrderMoney,
          type: 'bar'
        }]
      };
      option && myChart.setOption(option);
    },
  }
}
</script>
